import type {
  ComponentRef,
  EditorScriptFlowAPI,
  FlowEditorSDK,
} from '@wix/yoshi-flow-editor';

import type { WidgetSlot } from '../types';

export const getReorderedItems = <T>(
  sourceIndex: number,
  targetIndex: number,
  items: T[],
) => {
  const itemsCopy = [...items];
  const [itemToAdd] = itemsCopy.splice(sourceIndex, 1);

  itemsCopy.splice(targetIndex, 0, itemToAdd);

  return itemsCopy;
};

export const isCurrentLanguageOriginal = async (editorSDK: FlowEditorSDK) => {
  const language = editorSDK?.language;

  if (await language.multilingual.isEnabled('')) {
    const currentLanguageCode = await language.current.get('');
    const originalLanguage = await language.original.get('');

    return currentLanguageCode === originalLanguage.languageCode;
  }

  return true;
};

export const getLayoutPanelHeight = (
  environment: EditorScriptFlowAPI['environment'],
) => {
  const showCascadingIndicators = environment.isEditorX;

  if (showCascadingIndicators) {
    return 233;
  }

  return 200;
};

export const getIsEditor3 = () =>
  (globalThis as any).commonConfig?.host === 'EDITOR3';

export const getSlotDefinition = (
  slot: WidgetSlot,
  hostCompRef: ComponentRef,
) => {
  const isEditor3 = getIsEditor3();
  return isEditor3
    ? { hostCompRef, slotId: slot.id }
    : { slotCompRef: slot.compRef };
};
